import { render, staticRenderFns } from "./state_color.vue?vue&type=template&id=0316c61f&"
import script from "./state_color.vue?vue&type=script&lang=js&"
export * from "./state_color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports